<template>
	<div>
		<TerittoryManagement 
			:filter="territoryManagementFilter" 
			:options="options"
			:rangeOption="rangeOption"
			:data="data"
			:typeMap="'User Dealer'"
			@loadAPI="loadAPI"
			:trendSales="true"
		/>
	</div>
</template>

<script>
import TerittoryManagement from './../Highlight/tabChildren/territoryManagement'
import moment from 'moment'
export default {
	components : {
		TerittoryManagement
	},
	data() {
		return {
			data : {
				territory: null,
				territoryService : null,
				territorySalesByDocument: null,
				territoryMarket : null,
				territoryMarketDocument : null,
				territoryMarketDealer : null
			},
			territoryManagementFilter: {
				territoryOptions: {
					area: 'Jawa Timur',
					type: '',
					color: '',
					dealer: '',
					start : new moment().startOf('month').format("Y-MM-DD"),
					end : new moment().format("Y-MM-DD"),
					start_service : new moment().startOf('month').format("Y-MM-DD"),
					end_service : new moment().format("Y-MM-DD"),
					start_service_2 :  new moment().startOf('month').format("Y-MM-DD"),
					end_service_2 : new moment().format('Y-MM-DD'),
					mapType : 'By Kecamatan',
					includeServiceDate : true
				},
			},
			rangeOption : {
				Semester : {},
				Quarterly : {},
				Monthly : {}
			},
			options : this.$store.getters.getFilterOptions
		}
	},
	watch : {
		// 'territoryManagementFilter.territoryOptions' : {
		// 	deep : true,
		// 	handler () {
		// 		this.loadAPI()
		// 	}
		// }
	},
	mounted () {
		this.loadRangeOption()
		// this.loadAPI()
	},
	methods : {
		async loadAPI() {
			if(!this.territoryManagementFilter.territoryOptions.dealer)
				return
			
			let terittoryManagement = [
				'/territory-management',
				'/territory-management/service',
				'/territory-management/sales-by-document',
				'/territory-management/market-contribution?by=SCAN',
				'/territory-management/market-contribution?by=DOCUMENT',
				'/territory-management/market-contribution/by-dealer'
			]

			let territoryVar = [
				'territory',
				'territoryService',
				'territorySalesByDocument',
				'territoryMarket',
				'territoryMarketDocument',
				'territoryMarketDealer'
			]
			let url = '/api/highlight'
			this.data.territory = null
			this.data.territoryService = null

			for(var i = 0 ; i < terittoryManagement.length ; i++) {
				let urlTerritory = terittoryManagement[i]
				let varTerritory = territoryVar[i]
				let filter = '?'
				let filterOptions = await this.transformFilter(this.territoryManagementFilter.territoryOptions)
              	let individualFilter = await this.initialiseFilter(filter + '&' , filterOptions)
				this.$http.get(url + urlTerritory + individualFilter)
				.then((resp) => {
					this.data[varTerritory] = resp.data.data
					// console.log(terittoryManagement[i])
					// if(urlTerritory.includes('service')) {
					// 	this.data.territoryService = resp.data.data
					// }
					// else {
					// 	this.data.territory = resp.data.data
					// }
				})
				.catch((err) => {
					console.log(err)
				})
			}
		},
		loadRangeOption () {
			let startingYear = 2019
			let yearNow = parseInt(new moment().format("Y"))
			let monthNow = parseInt(new moment().format("M"))

			for(var i = yearNow; i >= startingYear ; i--) {
			
			this.rangeOption.Semester[`S2 ${i}`] = [new Date(i , 6 , 1) , new Date(i , 12 , 0)]
			this.rangeOption.Semester[`S1 ${i}`] = [new Date(i , 0 , 1) , new Date(i , 6 , 0)]

			this.rangeOption.Quarterly[`Q1 ${i}`] = [new Date(i , 0 , 1) , new Date(i , 3 , 0)]
			this.rangeOption.Quarterly[`Q2 ${i}`] = [new Date(i , 3 , 1) , new Date(i , 6 , 0)]
			this.rangeOption.Quarterly[`Q3 ${i}`] = [new Date(i , 6 , 1) , new Date(i , 9 , 0)]
			this.rangeOption.Quarterly[`Q4 ${i}`] = [new Date(i , 9 , 1) , new Date(i , 12 , 0)]
			}

			let unorderedMonth = {}

			for(var j = monthNow - 1 ; j >= monthNow - 12; j --) {
			let date = new moment(new Date(yearNow , j , 1));
			// console.log(date.format("Y") , date.format("M") , 1)
			unorderedMonth[`${date.format("MMM")} ${date.format("Y")}`] = [new Date(date.format("Y") , parseInt(date.format("M")) - 1 , 1) , new Date(date.format("Y"),parseInt(date.format("M")) ,0)]
			// console.log(unorderedMonth[`${date.format("MMM")} ${date.format("Y")}`])
			}

			// for(var j = monthNow - 1 ; j <= monthNow + 6; j ++ ){
			//   let date = new moment(new Date(yearNow , j , 1));
			//   unorderedMonth[`${date.format("MMM")} ${date.format("Y")}`] = [new Date(date.format("Y") , date.format("M") , 1) , new Date(date.format("Y"),date.format("M") + 1 ,0)]
			// }
		
			
			
			
			this.rangeOption.Monthly = unorderedMonth

		}
	}
	
}
</script>